module.exports = __webpack_public_path__ + "img/thunder.be5030ca.webp";